export enum TestStepScore {
    noScore = 0,
    correct = 1,
    incorrect = 2,
    inapplicable = 3,
    missingEvidence = 4,
}
